import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_URL } from "../../utils/auth";
import Auth from '../../utils/auth';
import './ContactSyncStatus.css';

const ContactSyncStatus = ({ clientId }) => {
    const [ghlSynced, setGhlSynced] = useState(false);
    const [loading, setLoading] = useState(true);
    const workspaceId = Auth.getWorkspaceId();
  
    useEffect(() => {
        const fetchGhlSyncStatus = async () => {
            if (!clientId || !workspaceId) {
                setLoading(false);
                return;
            }
            
            try {
                const response = await axios.get(`${API_URL}/clients/get-client-by-id`, {
                    params: {
                        clientId: clientId,
                        workspaceId: workspaceId,
                        includeCompany: true
                    }
                });
                const ghlSyncedValue = response.data.ghlSynced === true || response.data.ghlSynced === 'true' || response.data.ghlSynced === 1;
                setGhlSynced(ghlSyncedValue);
            } catch (err) {
                console.error("Failed to fetch GHL sync status:", err);
                setGhlSynced(false);
            } finally {
                setLoading(false);
            }
        };

        fetchGhlSyncStatus();
    }, [clientId, workspaceId]);

    if (loading) {
        return null;
    }

    return (
        <div className="contact-sync-status-card">
            <h2 className="contact-sync-status-heading">Contact</h2>
            <div className="contact-sync-status-content">
                <span 
                    className="contact-sync-status-dot"
                    style={{ 
                        backgroundColor: ghlSynced ? '#03BC72' : '#F52B53'
                    }}
                ></span>
                <span 
                    className="contact-sync-status-text"
                    style={{ 
                        color: ghlSynced ? '#03BC72' : '#F52B53'
                    }}
                >
                    {ghlSynced ? 'Synced with HighLevel' : 'Not Synced with HighLevel'}
                </span>
            </div>
        </div>
    );
};

export default ContactSyncStatus;

